'use strict';

angular.module('amexReconciliationApp')
  .service('UserRepository', function UserRepository($resource) {
    var self = this;

    var userResource = $resource('/api/v1/authenticatedUser');

    self.getAuthenticatedUser = function () {
      return userResource.get().$promise;
    };

    self.getPreviousUser = function () {
      return $resource('/api/v1/previousUser').get().$promise;
    };

    self.fetchApprovalUserNames = function (userIds) {
      return $resource('api/v1/userNames').get({userIds: userIds}).$promise;
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/UserRepository.js
// module id = 630
// module chunks = 0